export default __webpack_public_path__ + "media/src/usersite/images/header/default_user-99d72d65c6cd6c8648fe51fad1dbf3f2.png";